import React, { Component } from 'react';
import './Configminore.css';
import "../../CommonStyles/CSS.css"
import back from '../../images/public/registeration/back.png';
import help from '../../images/public/userarea/tab5u.png';
import noImage from '../../images/public/noImage.png';
import firstcard from '../../images/public/registeration/CardSki1.svg';
import secondcard from '../../images/public/registeration/CardSki2.svg';
//import cltc from '../../images/public/registeration/cltc.png';
//import crdj from '../../images/public/registeration/crdj.png';
//import crdb from '../../images/public/registeration/crdb.png';
//import snst from '../../images/public/registeration/snst.png';
//import clos from '../../images/public/registeration/clos.png';
//import crdscia from '../../images/public/userarea/crdscia.png';//adult
//import crdscis from '../../images/public/userarea/crdscis.png';//senior
//import crdscij from '../../images/public/userarea/crdscij.png';//junior
//import crdscib from '../../images/public/userarea/crdscib.png';//baby
//import crdpagana from '../../images/public/userarea/crdpagana.png';//adult-axess
//import crdpaganj from '../../images/public/userarea/crdpaganj.png';//junior-axess
//import crdpaganb from '../../images/public/userarea/crdpaganb.png';//baby-axess
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isIOS } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date';
//import { checkCategory, getServicePrice, checkIfCanBuyCard, addToCart, buyAnotherCard, checkCart, getServiceDescription, userLogoutFetch } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Dropdown from 'react-dropdown';
// import renderHTML from 'react-render-html';
//import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ReactHtmlParser from 'react-html-parser';
import Cookies from 'universal-cookie';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
//import { HtmlWrapper, fontStyles } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
//import { Button, Container, Row, Col } from 'react-bootstrap';
//import { zIndex } from 'material-ui/styles';
import MPWorkFlow from '../../libs/workflow';
// const stageName = "Skier";
import TopBar from '../../assets/components/topbar/TopBar';
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import miniArrow from '../../images/public/registeration/miniarrow.png';
import logo from '../../images/public/login/logo.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
import CardSki1 from '../../images/public/registeration/CardSki1.svg';
import CardSki2 from '../../images/public/registeration/CardSki2.svg';

const cookies = new Cookies();

class Configminore extends Component {
	constructor(props) {
		super(props);

		let params = null;
		//console.log('[config-card]', params);
		this.state = {
			step: '2',
			loadedData: false,
			// isLoading: false,
			minor: false,
			checked: "0",
			radio1: false,
			radio2: false,
			modal: false,
			alertRegistered: false,
			difText: false,
			cart: null,
			dayList: [],
			day: '',
			month: '',
			year: '',
			//date of birth
			dob: null,
			type: null,//card type: adult, baby, senior, junior, etc.
			cardImage: null,
			errmsg: null,
			errorFlg: false,
			purchaseCart: null,
			oncardPrices: 0,
			isSecondCard: false,// is used when user added the second card, we use it to disable modifications
			purchaseHere: false,
			// new flow states
			// userOptions: [],
			canProceed: false,
			helpShow: false,
			helpMessage:"",   
			refresh: true,
			gender: "",
			genderRefresh: false,
			// for mobile issue
			screenClickable: true,
		};
	}

	//new functions for new flow
	componentDidMount() {
		// this.wf = new MPWorkFlow();
		// this.init();
		this.refreshDays();
		this.refresh();
	}

	alertResponse(info) {
		switch (info.type) {
			case "closeButton":
				this.setState({ errorFlg: false })
				break;
            case "actionButton":
              if (info.option1 === "attention") {
								this.setState({ errorFlg: false })
								break;
				}
		}
	} 

	async init() {
		// update screenData for current states
		// await getWorkFlow(this, stageName);
		await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Skier"));
		this.update();
	}

	async update() {
		// updating server state...
		let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
		//console.log('[config-card] @update #resp', resp);
		if (!resp) return;
		if (resp.status === "success") {
				// Track new skier configuration
				const user = JSON.parse(localStorage.getItem('user') || '{}');
				const FirebaseLogger = require('../../libs/FirebaseLogger').default;
				FirebaseLogger.getInstance().regEvent("SKIER_CONFIGURED", {
					user_id: user.user_id,
					skier_type: this.state.screenData.skier_type || 'unknown'
				}, "SUCCESS");

				// updating localStorage
				MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
				// updating current screen
				this.refresh();
		} /* else if (resp.status === "fail") {
				// call state and update the storage
				this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });

		} */
  }

	async refresh() {
			// update screenData for current states
			await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Skier"));

			this.setState({ canProceed: this.state.screenData.link_next != "" });
			// console.log('this.state.screenDatascreenData',this.state.screenData);
			// populating the screen content
			const {
					name,
					name_pholder,
					surname,
					surname_pholder,
					birthday,
					edit_allowed,
					gender,
					female_label,
					male_label,
					postcode_pholder,
					postcode,
					data_label,
			} = this.state.screenData;
			//console.log(
			//		'[config-card] @refresh',
			//		name,
			//		name_pholder,
			//		surname,
			//		surname_pholder,
			//		birthday,
			//		edit_allowed,
			//		gender,
			//		female_label,
			//		male_label,
			//		postcode_pholder,
			//		postcode,
			//		data_label,
			//);

		this.setState({isSecondCard: !edit_allowed});

		// name/surname
		document.getElementById("ski-card-name").placeholder = name_pholder;
		document.getElementById("ski-card-name").value = name;
		document.getElementById("ski-card-surename").placeholder = surname_pholder;
		document.getElementById("ski-card-surename").value = surname;
		document.getElementById("ski-card-postcode").placeholder = postcode_pholder;
		document.getElementById("ski-card-postcode").value = postcode;
		// ski-card-postcode
		// gender
		if (gender === "male")
			this.setState({ radio1: true, radio2: false });
		else if (gender === "female") this.setState({ radio1: false, radio2: true });
			this.refreshGender();
			document.getElementById("gender-male").innerHTML = male_label + (document.getElementById("gender-male").innerHTML).replace(male_label, "");
			document.getElementById("gender-female").innerHTML = female_label + (document.getElementById("gender-female").innerHTML).replace(female_label, "");
			this.setState({gender: gender});
		
		// birthday
		var bdayArr = !birthday ? [] : birthday.split("-");
		//console.log('[config-card] @transit #bdayArr', bdayArr);
		if (bdayArr.length > 0) {
				// no need to call this.onUserOptionChanged(); since it is only needed to update the server,
				// because refresh is used to populate already fetch content
				this.setState({ dob: { ...this.state.dob, yyyy: bdayArr[0], mm: bdayArr[1], dd: bdayArr[2] } });
		}
		// checking the ski card images
		this.setValidImage(this.state.screenData.icons);
  }

	async transit(toWhere) {
    console.log('before workflowTransition 3');
		let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
		//console.log('[config-card] @transit #resp', resp);

		if (resp.status === "success") {
				// updating localStorage and navigating to the new screen
				MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
				let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
				// console.log("[config-card] @gotoResorts #getRouteName:", nextScreen);
				return this.props.history.push(nextScreen);
		} /*else if (resp.status === "fail") {
				this.setState({ errorFlg: true, errmsg: resp.message });
		}*/

	}

	refreshDays() {
		let { month, year } = this.state;
		var d = new Date();
		if (!month) {
				month = d.getMonth() + 1;
		}
		if (!year) {
				year = d.getFullYear();
		}
		this.setState({ dayList: getDaysInMonth(Number(month), Number(year)) }, () => {
				if (Number(this.state.day) > this.state.dayList.length) this.setState({ day: this.state.dayList.length.toString() });
		});
	}

	setValidImage(images) {
		if (!images) return;
		images.map((img, index)=> {
			let id = `ski-card-config-${index}`;
			var request = new XMLHttpRequest();
			request.open('GET', img, true);
			request.onreadystatechange = function () {
				if (request.readyState === 4) {
					if (request.status === 404)
						document.getElementById(id).src = noImage;
					else 
					{
						if(img === 'https://user.mypass.cc/exhibits/card_mypass.png')
							document.getElementById(id).src = CardSki1;
						if(img === 'https://user.mypass.cc/exhibits/card_paganella.jpg')
							document.getElementById(id).src = CardSki2;
					}
				}
			};
			request.send();
		})
  }

	refreshGender() {
		this.setState({ genderRefresh: true }, () => {
			this.setState({ genderRefresh: false });
		})
	}

	onGenderChanged = (gender) => {
		// console.log("gender", gender);
		if (gender === "male")
			this.setState({ radio1: true, radio2: false, gender: gender },()=>{this.onUserOptionChanged();});
			else this.setState({ radio1: false, radio2: true, gender: gender },()=>{this.onUserOptionChanged();});
	}

	onUserOptionChanged = () => {
		let name, surname, gender, birthday, postcode;
		name = document.getElementById("ski-card-name").value;
		surname = document.getElementById("ski-card-surename").value;
		postcode = document.getElementById("ski-card-postcode").value;
		gender = this.state.gender;
		if (this.state.dob && this.state.dob.dd && this.state.dob.mm && this.state.dob.yyyy) {
				birthday = this.state.dob.yyyy + "-" + this.state.dob.mm + "-" + this.state.dob.dd;
		}
		//console.log("[config-card] @onUserOptionChanged #name:", name);
		//console.log("[config-card] @onUserOptionChanged #surname:", surname);
		//console.log("[config-card] @onUserOptionChanged #gender:", gender);
		//console.log("[config-card] @onUserOptionChanged #birthday:", birthday);
		//console.log("[config-card] @onUserOptionChanged #postcode:", postcode);
		let screenData = this.state.screenData;
		screenData.name= name;
		screenData.surname= surname;
		screenData.gender= gender;
		screenData.postcode= postcode;
		screenData.birthday = birthday ? birthday : "";
		//console.log("[config-card] @onUserOptionChanged #screenData:", screenData);
		this.update();
  }

	helpShowModal = (help_tag) => {
		MPWorkFlow.getInstance().workflowHelp(this, {tag: help_tag});
	}

	onBack = () => {
		//return this.props.history.push('/');
		this.transit(this.state.screenData.link_back);
	}

	gotoNextStage = (e) => {
		e.preventDefault();
		this.transit(this.state.screenData.link_next);
	}
    
	// for mobile view issue on dropdown that is not clickable when is open
	screenClickable(isClickable){
		this.setState({screenClickable: isClickable});
	}

	render() {
		//console.log('[config-card]', this.state);
		function capitalize(s) {
			return s && s[0].toUpperCase() + s.slice(1);
		}
		return (
			<Router>
				<div>
					<div>
						<BrowserView>
							<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
								<div className="row flex-nowrap">
									<div className="col-2 d-flex align-items-center">
										<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
									</div>
									<div className="col-8 d-flex align-items-center justify-content-center">
										<img className="sn_mobile_top_row_logo" src={ logo } />
									</div>
									<div className="col-2 d-flex align-items-center justify-content-end">
										<button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={ help }/></button>
									</div>
								</div>
							</div>
              <div className="sn_topbar"><TopBar step={ this.state.step }/></div>
              <div className="sn_overlay d-lg-none"></div>
							<div className="sn_minor">
								<div className="container">
									<div className="row">
										<div className="col-12 col-lg-10 mx-auto">
											<div className="sn_register__container p-3 p-md-4 p-lg-5">
												<div className="row d-none d-lg-flex">
													<div className="col-12 d-flex justify-content-end">
													{
														this.state.screenData && this.state.screenData.help_tag &&
														<div className="sn_quest">
															<a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
																<img src={ help }/>
															</a>
														</div>
													}
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12 text-center">
														<h3>{ this.state.screenData && HtmlWrapper(this.state.screenData.title) }</h3>
														<h5>{ this.state.screenData && HtmlWrapper(this.state.screenData.desc) }</h5>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12">
														<div className="sn_minor__container__wrapper">
															{
																this.state.screenData && 
																this.state.screenData.icons.map((icon, index) =>
																{
																	return  <div className="sn_minor__container__wrapper__image">
																						<img id={`ski-card-config-${index}`} key={`ski-card-config-key${index}`} className="skicard-image" />
																					</div>
																})
															}
														</div>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12">
														<p>
															{ this.state.screenData && ReactHtmlParser(this.state.screenData.long_desc) }
															{ this.state.screenData && ReactHtmlParser(this.state.screenData.form_title) }
														</p>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12 col-md-6">
															<input className="sn_input" onBlur={()=>{this.onUserOptionChanged();}} id={"ski-card-name"}  disabled={this.state.isSecondCard} spellCheck="false" type="text"/>
													</div>
													<div className="col-12 col-md-6">
															<input className="sn_input" onBlur={()=>{this.onUserOptionChanged();}} id={"ski-card-surename"}  disabled={this.state.isSecondCard} spellCheck="false" type="text"/>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12 col-md-6 mb-3">
														<p className="text-right">{ tr.t("Birthday") }</p>
													</div>
													{
														this.state.isSecondCard ?
														<div className="col-12 col-md-6">
															<div className="sn_minor__container__date">
																<div className="disabled-dob-label" disabled={this.state.isSecondCard} spellCheck="false" type="text">
																	{this.state.dob && (this.state.dob.dd + "-" + this.state.dob.mm + "-" + this.state.dob.yyyy)}
																</div>
															</div>
														</div>
														:
														<div className="col-12 col-md-6">
															<div className="sn_minor__container__date">
																<Dropdown
																	arrowClassName='myArrowClassName'
																	menuClassName={'dopbtnid sn_datemenu'}
																	controlClassName={'dbuttonid sn_datebutton'}
																	options={this.state.dayList}
																	placeholder={tr.t("Day")}
																	value={this.state.dob?this.state.dob.dd:null}
																	onChange={(day) => {
																			this.setState({ dob: { ...this.state.dob, dd: day.value }, day: day.value }, () => {
																					this.refreshDays();
																					this.onUserOptionChanged();
																			});
																	}}
																	disabled={this.state.isSecondCard}
																/>
																<Dropdown
																	arrowClassName='myArrowClassName'
																	menuClassName={'mopbtnid sn_datemenu'}
																	controlClassName={'mbuttonid sn_datebutton'}
																	options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']}
																	placeholder={tr.t("Month")}
																	onChange={((info) => {
																			this.setState({ dob: { ...this.state.dob, mm: info.value }, month: info.value }, () => {
																					this.refreshDays();
																					this.onUserOptionChanged();
																			});
																	})}
																	value={this.state.dob?this.state.dob.mm:null}
																	disabled={this.state.isSecondCard}
																/>
																<Dropdown
																	arrowClassName='myArrowClassName'
																	menuClassName={'yopbtnid sn_datemenu'}
																	controlClassName={'ybuttonid sn_datebutton'}
																	options={getYears().reverse()}
																	placeholder={tr.t("Year")}
																	onChange={((info) => {
																			this.setState({ dob: { ...this.state.dob, yyyy: info.value.toString() }, year: info.value.toString() }, () => {
																					this.refreshDays();
																					this.onUserOptionChanged();
																			});
																	})}
																	value={this.state.dob?this.state.dob.yyyy:null}
																	disabled={this.state.isSecondCard}
																/>
															</div>
														</div>
													}
												</div>
												{
													!this.state.genderRefresh &&
													<div className="row mb-4">
														{
															this.state.isSecondCard ?
															<div className="col-12">
																<div className="sn_minor__container__wrapCheck">
																	<label id="gender-male" className={this.state.radio1 ? "radioBold" : "containerrdhtt"}>
																		<input disabled={this.state.isSecondCard} type="radio" name="radio" checked={this.state.radio1} />
																		<span className="checkmark"></span>
																	</label>
																	<label id="gender-female" className={this.state.radio2 ? "radioBold" : "containerrdhtt"} >
																		<input disabled={this.state.isSecondCard} type="radio" name="radio"  checked={this.state.radio2} />
																		<span className="checkmark"></span>
																	</label>
																</div>
															</div>
															:
															<div className="col-12">
																<div className="sn_minor__container__wrapCheck">
																	<label onClick={()=>this.onGenderChanged("male")} id="gender-male" className={this.state.radio1 ? "radioBold" : "containerrdhtt"}>
																		<input disabled={this.state.isSecondCard} type="radio" name="radio"  checked={this.state.radio1} />
																		<span className="checkmark"></span>
																	</label>
																	<label onClick={()=>this.onGenderChanged("female")} id="gender-female" className={this.state.radio2 ? "radioBold" : "containerrdhtt"} >
																		<input disabled={this.state.isSecondCard} type="radio" name="radio" checked={this.state.radio2} />
																		<span className="checkmark"></span>
																	</label>
																</div>
															</div>
														}
												</div>
												}
												<div className="row mb-4">
													<div className="col-12">
															<input className="sn_input mb-2" onBlur={ ()=>{this.onUserOptionChanged();} } id={ "ski-card-postcode" }  disabled={ this.state.isSecondCard } spellCheck="false" type="text"/>
															<p className="sn_minitext">{ this.state.screenData && HtmlWrapper(this.state.screenData.data_label) }</p>
													</div>
												</div>     
												<div className="row">
													<div className="col-12 d-flex flex-column flex-column-reverse align-items-center flex-sm-row justify-content-end mb-3">
														<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={ this.onBack }>{ tr.t('back') }</button>
														<button disabled={!this.state.canProceed} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
													</div>
												</div>
												<div className="row d-lg-none mt-5">
													<div className="col-12">
														<ProgressBullets step={ this.state.step } />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</BrowserView>
						<MobileView>
							<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
								<div className="row flex-nowrap">
									<div className="col-2 d-flex align-items-center">
										<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
									</div>
									<div className="col-8 d-flex align-items-center justify-content-center">
										<img className="sn_mobile_top_row_logo" src={ logo } />
									</div>
									<div className="col-2 d-flex align-items-center justify-content-end">
										<button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={ help }/></button>
									</div>
								</div>
							</div>
              <div className="sn_topbar"><TopBar step={ this.state.step }/></div>
              <div className="sn_overlay d-lg-none"></div>
							<div className="sn_minor">
								<div className="container">
									<div className="row">
										<div className="col-12 col-lg-8 mx-auto">
											<div className="sn_register__container p-3 p-md-4 p-lg-5">
												<div className="row d-none d-lg-flex">
													<div className="col-12 d-flex justify-content-end">
													{
														this.state.screenData && this.state.screenData.help_tag &&
														<div className="sn_quest">
															<a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
																<img src={ help }/>
															</a>
														</div>
													}
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12 text-center">
														<h3>{ this.state.screenData && HtmlWrapper(this.state.screenData.title) }</h3>
														<h5>{ this.state.screenData && HtmlWrapper(this.state.screenData.desc) }</h5>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12">
														<div className="sn_minor__container__wrapper">
															{
																this.state.screenData && 
																this.state.screenData.icons.map((icon, index) =>
																{
																	return  <div className="sn_minor__container__wrapper__image">
																						<img id={`ski-card-config-${index}`} key={`ski-card-config-key${index}`} className="skicard-image" />
																					</div>
																})
															}
														</div>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12">
														<p>
															{ this.state.screenData && ReactHtmlParser(this.state.screenData.long_desc) }
															{ this.state.screenData && ReactHtmlParser(this.state.screenData.form_title) }
														</p>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12 col-md-6">
															<input className="sn_input" onBlur={()=>{this.onUserOptionChanged();}} id={"ski-card-name"}  disabled={this.state.isSecondCard} spellCheck="false" type="text"/>
													</div>
													<div className="col-12 col-md-6">
															<input className="sn_input" onBlur={()=>{this.onUserOptionChanged();}} id={"ski-card-surename"}  disabled={this.state.isSecondCard} spellCheck="false" type="text"/>
													</div>
												</div>
												<div className="row mb-4">
													<div className="col-12 col-md-6 mb-3">
														<h5>{ tr.t("Birthday") }</h5>
													</div>
													{
														this.state.isSecondCard ?
														<div className="col-12 col-md-6">
															<div className="sn_minor__container__date">
																<div className="disabled-dob-label" disabled={this.state.isSecondCard} spellCheck="false" type="text">
																	{this.state.dob && (this.state.dob.dd + "-" + this.state.dob.mm + "-" + this.state.dob.yyyy)}
																</div>
															</div>
														</div>
														:
														<div className="col-12 col-md-6">
															<div className="sn_minor__container__date">
																<Dropdown
																	arrowClassName='myArrowClassName'
																	menuClassName={'dopbtnid sn_datemenu'}
																	controlClassName={'dbuttonid sn_datebutton'}
																	options={this.state.dayList}
																	placeholder={tr.t("Day")}
																	value={this.state.dob?this.state.dob.dd:null}
																	onChange={(day) => {
																			this.setState({ dob: { ...this.state.dob, dd: day.value }, day: day.value }, () => {
																					this.refreshDays();
																					this.onUserOptionChanged();
																			});
																	}}
																	disabled={this.state.isSecondCard}
																/>
																<Dropdown
																	arrowClassName='myArrowClassName'
																	menuClassName={'mopbtnid sn_datemenu'}
																	controlClassName={'mbuttonid sn_datebutton'}
																	options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']}
																	placeholder={tr.t("Month")}
																	onChange={((info) => {
																			this.setState({ dob: { ...this.state.dob, mm: info.value }, month: info.value }, () => {
																					this.refreshDays();
																					this.onUserOptionChanged();
																			});
																	})}
																	value={this.state.dob?this.state.dob.mm:null}
																	disabled={this.state.isSecondCard}
																/>
																<Dropdown
																	arrowClassName='myArrowClassName'
																	menuClassName={'yopbtnid sn_datemenu'}
																	controlClassName={'ybuttonid sn_datebutton'}
																	options={getYears().reverse()}
																	placeholder={tr.t("Year")}
																	onChange={((info) => {
																			this.setState({ dob: { ...this.state.dob, yyyy: info.value.toString() }, year: info.value.toString() }, () => {
																					this.refreshDays();
																					this.onUserOptionChanged();
																			});
																	})}
																	value={this.state.dob?this.state.dob.yyyy:null}
																	disabled={this.state.isSecondCard}
																/>
															</div>
														</div>
													}
												</div>
												{
													!this.state.genderRefresh &&
													<div className="row mb-4">
														{
															this.state.isSecondCard ?
															<div className="col-12">
																<div className="sn_minor__container__wrapCheck">
																	<label id="gender-male" className={this.state.radio1 ? "containerrdhtb" : "containerrdhtt"}>
																		<input disabled={this.state.isSecondCard} type="radio" name="radio" checked={this.state.radio1} />
																		<span className="checkmark"></span>
																	</label>
																	<label id="gender-female" className={this.state.radio2 ? "containerrdhtb" : "containerrdhtt"} >
																		<input disabled={this.state.isSecondCard} type="radio" name="radio"  checked={this.state.radio2} />
																		<span className="checkmark"></span>
																	</label>
																</div>
															</div>
															:
															<div className="col-12">
																<div className="sn_minor__container__wrapCheck">
																	<label onClick={()=>this.onGenderChanged("male")} id="gender-male" className={this.state.radio1 ? "containerrdhtb" : "containerrdhtt"}>
																		<input disabled={this.state.isSecondCard} type="radio" name="radio"  checked={this.state.radio1} />
																		<span className="checkmark"></span>
																	</label>
																	<label onClick={()=>this.onGenderChanged("female")} id="gender-female" className={this.state.radio2 ? "containerrdhtb" : "containerrdhtt"} >
																		<input disabled={this.state.isSecondCard} type="radio" name="radio" checked={this.state.radio2} />
																		<span className="checkmark"></span>
																	</label>
																</div>
															</div>
														}
												</div>
												}
												<div className="row mb-4">
													<div className="col-12">
															<input className="sn_input mb-2" onBlur={ ()=>{this.onUserOptionChanged();} } id={ "ski-card-postcode" }  disabled={ this.state.isSecondCard } spellCheck="false" type="text"/>
														<h6>{ this.state.screenData && HtmlWrapper(this.state.screenData.data_label) }</h6>
													</div>
												</div>     
												<div className="row">
													<div className="col-12 d-flex flex-column flex-column-reverse align-items-center flex-sm-row justify-content-end mb-3">
														<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={ this.onBack }>{ tr.t('back') }</button>
														<button disabled={!this.state.canProceed} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
													</div>
												</div>
												<div className="row d-lg-none mt-5">
													<div className="col-12">
														<ProgressBullets step={ this.state.step } />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</MobileView>
						{
							this.state.modal ?
							<div className="containerModal">
							{
								this.state.alertRegistered ?
								<AlertPnl textbar1={tr.t("Alreadyreg")} secondbar={true} textbar2={tr.t("Ifuwant")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
							}
							</div> : null
						}
						{
							this.state.errorFlg ?
							<div className="containerModal">
							{
								this.state.errorFlg ?
								<AlertPnl textbar1={ tr.t("Attention") } secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
							}
							</div> : null
						}
					</div>
					{
						this.state.errorFlg_userinfo ?
						<div className="containerModal">
						{
							this.state.errorFlg_userinfo ?
							<AlertPnl textbar1={ tr.t("Attention") } secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"errorFlg_userinfo"} callback={this.alertResponse.bind(this)} /> : null
						}
						</div> : null
					}
					<WaitLoad enable={ this.state.workFlowInProgress } />
					{this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
				</div>
			</Router>
      );
    }
}

var formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'EUR',
	minimumFractionDigits: 2,
});
export default Configminore;

/**
 * @param {int} The month number, 0 based
 * @param {int} The year, not zero based, required to account for leap years
 * @return {Date[]} List with date objects for each day of the month
 */

function getDaysInMonth(month, year) {
	month -= 1;
	console.log("get days 3", month, year);
	var date = new Date(year, month, 1);
	var days = [];
	while (date.getMonth() === month) {
		days.push(new Date(date).getUTCDate());
		date.setDate(date.getDate() + 1);
	}
	days.push(days.length)
	days.splice(0, 1);
	for (var i in days) {
		days[i] = days[i].toString().padStart(2, '0');
	}
	return days;
}

function getYears(startYear) {
	var currentYear = new Date().getFullYear(), years = [];
	startYear = startYear || 1900;
    while (startYear <= currentYear) {
			years.push(startYear++);
    }
	return years;
}


// WEBPACK FOOTER //
// ./src/screens/Configminore/Configminore.js